import React from 'react';
import { Label } from '../ui/label';
import BranchPickerMenu from './BranchPickerMenu';

export default function BranchPicker() {
  return (
    <div>
      <Label>Branch</Label>
      <BranchPickerMenu variant="settings" align="start" />
      <p className="text-xs text-muted-foreground mt-1.5">
        Switch branch to view and manage that campus like a separate account.
      </p>
    </div>
  );
}
